// extracted by mini-css-extract-plugin
module.exports = {"optionBoxDes":"OptionBoxDes-module-optionBoxDes--pE8BG","options":"OptionBoxDes-module-options--CdJYp","btnFixed":"OptionBoxDes-module-btnFixed--O1ITo"};